<template>
    <!--<div>这是服务页面</div>-->
    <div class="servicePage">
        <div class="bigTitle bigTitle1">服務條款</div>
        <div class="contentText contentText1">本服務條款（以下簡稱「本條款」）係為澈見國際資訊有限公司（以下簡稱「本公司」）所制訂，
            並提供所有本公司手機、平板應用程式（APP）、後台管理（網頁）或本公司官方網站中之各項及相關產品與服務（以下簡稱「本服務」）之使用約定，
            使用本服務的用戶（以下簡稱「用戶」）同意之使用約定內容。
        </div>
        <div class="smallTitle smallTitle1">一、認識與接受條款</div>
        <div class="contentText contentText2">1. 當用戶使用本服務時，即表示用戶已閱讀、瞭解並同意接受本條款之所有內容。
            本公司有權於任何時間修改或變更本條款之內容，建議用戶隨時注意該等修改或變更。
            用戶於任何修改或變更後繼續使用本服務，視為用戶已閱讀、瞭解並同意接受該等修改或變更。
            2. 如用戶為未成年人，須經過親權人等法定代理人同意後，方能使用本服務。
        </div>
        <div class="smallTitle smallTitle2">二、發布條款</div>
        <div class="contentText contentText3">當用戶使用本服務時，即表示用戶已閱讀、瞭解並同意接受本條款之所有內容。</div>
        <div class="bigTitle bigTitle2">隱私政策</div>
        <div class="contentText contentText4">當用戶使用本服務時，即表示用戶已閱讀、瞭解並同意接受本條款之所有內容。
            本公司有權於任何時間修改或變更本條款之內容，建議用戶隨時注意該等修改或變更。
            用戶於任何修改或變更後繼續使用本服務，視為用戶已閱讀、瞭解並同意接受該等修改或變更。
        </div>
    </div>
</template>

<script>
export default {
  name: 'Service'
}
</script>

<style scoped lang="scss">

    $marginLeft: 20pt;

    .servicePage{
        color: #262626;
        background-color: white;
    }
    .bigTitle{
        font-size: 34pt;
        margin-left: $marginLeft;

    }
    .smallTitle{
        font-size: 20pt;
        margin-left: $marginLeft;
        margin-right: $marginLeft;
        font-weight: bold;
    }
    .contentText{
        font-size: 20pt;
        margin-left: $marginLeft;
        margin-right: $marginLeft;
    }

    .bigTitle1{
        margin-top: 50pt;
    }
    .contentText1{
        margin-top: 22pt;
    }
    .smallTitle1{
        margin-top: 16pt;
    }
    .contentText2 {
        margin-top: 8pt;
    }
    .smallTitle2{
        margin-top: 16pt;
    }
    .contentText3{
        margin-top: 8pt;
    }
    .bigTitle{
        margin-top: 64pt;
    }
    .contentText4{
        margin-top: 16pt;
        margin-bottom: 126pt;
    }

</style>